// Overlays (Bottom-Sheets) nutzen position:fixed + hohen z-index, um wie ein natives App-Modal
// über die GESAMTE Seite zu liegen. Problem: Falls irgendein Vorfahre auf der Host-Seite einen
// eigenen Stacking-Context aufmacht (transform, position:relative+z-index, isolation, etc.),
// wird unser z-index nur INNERHALB dieses Kontexts verglichen, nicht global - spätere
// Seitenabschnitte können dann trotzdem drüber gemalt werden.
//
// Lösung: Die Overlays per <Teleport> direkt zu einem Element machen, das ein direktes Kind von
// <body> ist - damit entkommen sie JEDEM Vorfahren-Stacking-Context der Host-Seite. Damit dabei
// nicht unser gekapseltes CSS verloren geht, bekommt dieses Portal-Element einen eigenen
// Shadow-Root mit genau denselben Styles nochmal injiziert.
import styles from '../style.css?inline'

let cachedContentEl = null

export function getPortalTarget() {
  if (cachedContentEl) return cachedContentEl

  const host = document.createElement('div')
  host.setAttribute('data-tm-spielplan-portal', '')
  // Der Host selbst braucht keine Größe/Position - nur sein Shadow-Root-Inhalt bekommt später
  // position:fixed von unseren Overlay-Styles, dafür reicht ein unsichtbares Ankerelement.
  document.body.appendChild(host)

  const shadow = host.attachShadow({ mode: 'open' })

  const styleEl = document.createElement('style')
  styleEl.textContent = styles
  shadow.appendChild(styleEl)

  const content = document.createElement('div')
  shadow.appendChild(content)

  cachedContentEl = content
  return content
}